import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.common.white,
    overflowX: 'hidden',
  },
  textWrapper: {
    width: '70%',
    margin: '0 auto',
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    '&>div>.rich-paragraph': {
      marginTop: 0,
      marginBottom: theme.spacing(2),
      '&>a': {
        color: theme.palette.blue.main,
        fontWeight: 700,
        boxShadow: 'none',
      },
    },
    '&>div>hr': {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(8),
    },
    '&>div>ul>li': {
      marginBottom: theme.spacing(1),
      '&::before': {
        backgroundColor: 'black',
      },
      '&>div': {
        marginBottom: '0 !important',
      },
    },
    [theme.breakpoints.down('xs')]: {
      width: '95%',
    },
  },
}))

export default useStyles
